<template>
  <div class="terms-container">
    <h1>이용약관</h1>

    <section>
      <p>
        본 약관은 리디아트리(이하 "회사")가 제공하는 "인생의 역점" 웹사이트 및
        관련 서비스의 이용과 관련하여 회사와 이용자의 권리, 의무 및 책임사항을
        규정함을 목적으로 합니다.
      </p>
    </section>

    <section>
      <h2>제1조 (목적)</h2>
      <p>
        이 약관은 회사가 운영하는 “인생의 역점” 웹사이트에서 제공하는 서비스
        이용에 있어 회사와 이용자 간의 권리 및 의무를 정함을 목적으로 합니다.
      </p>
    </section>

    <section>
      <h2>제2조 (정의)</h2>
      <ul>
        <li>
          "서비스"란 회사가 제공하는 점괘, 오행 정보, 체질 분석 등 웹 기반
          콘텐츠를 말합니다.
        </li>
        <li>
          "이용자"란 본 약관에 동의하고 서비스를 이용하는 자를 의미합니다.
        </li>
      </ul>
    </section>

    <section>
      <h2>제3조 (약관의 게시와 개정)</h2>
      <p>
        회사는 본 약관을 서비스 초기화면에 게시하며, 관계법령을 위반하지 않는
        범위에서 개정할 수 있습니다. 개정 시 적용일자와 개정사유를 명시하여 사전
        공지하며, 이용자는 변경된 약관에 동의하지 않을 경우 서비스 이용을 중단할
        수 있습니다.
      </p>
    </section>

    <section>
      <h2>제4조 (서비스의 제공 및 변경)</h2>
      <p>회사는 다음과 같은 서비스를 제공합니다:</p>
      <ul>
        <li>주역점 및 점괘 해석 서비스</li>
        <li>오행 분석, 날씨, 체질 기반 사주 분석 서비스</li>
        <li>사주, 오행 기반 올해의 운세 서비스</li>
        <li>주역 기반 실시간 운세 서비스</li>
        <li>기타 회사가 추가 제공하는 제휴 서비스 등</li>
      </ul>
      <p>
        서비스 내용은 회사의 사정에 따라 변경될 수 있으며, 사전 공지 후 수정될
        수 있습니다.
      </p>
    </section>

    <section>
      <h2>제5조 (서비스 이용 및 정보 제공)</h2>
      <p>
        이용자는 별도의 회원 가입 없이 서비스를 이용할 수 있으며, 서비스 이용을
        위해 생년월일, 체질 정보 등 일부 건강 관련 데이터를 입력할 수 있습니다.
        회사는 해당 정보를 기반으로 맞춤형 콘텐츠를 제공합니다.
      </p>
      <p>
        이용자가 정보 입력 시나 결제 시 발급되는 복구코드를 보관한 경우, 아래
        제6조에 의해 정보가 삭제되지 않은 이상 해당 코드를 통해 이용자 정보를
        복구할 수 있습니다.
      </p>
    </section>

    <section>
      <h2>제6조 (이용자 정보 보관 및 자동 삭제)</h2>
      <p>
        회사는 서비스 이용 중 입력된 정보를 일정 기간 동안 임시 보관하며, 다음
        기준에 따라 삭제합니다:
      </p>
      <ul>
        <li>
          최근 접속일로부터 6개월 이상 서비스 이용 기록이 없는 경우, 해당
          이용자의 정보는 자동 삭제됩니다.
        </li>
        <li>
          삭제된 정보는 복구되지 않으며, 회사는 복구에 대한 책임을 지지
          않습니다.
        </li>
      </ul>
    </section>

    <section>
      <h2>제7조 (포인트 충전 및 환불)</h2>
      <p>
        포인트 충전 서비스의 결제 및 환불에 대한 상세 규정은 별도의 「포인트
        충전 서비스 이용 규정」을 따릅니다.
      </p>
    </section>

    <section>
      <h2>제8조 (면책조항)</h2>
      <p>
        회사는 천재지변, 기술적 오류, 이용자의 귀책사유로 인한 서비스 장애에
        대하여 책임지지 않습니다. 또한, 서비스 정보를 활용한 행위에 따른 손해에
        대해 법적 책임을 지지 않습니다.
      </p>
    </section>

    <section>
      <h2>제9조 (지적재산권)</h2>
      <p>
        서비스의 모든 콘텐츠(텍스트, 이미지, 코드 등)의 저작권은 회사 또는
        제휴사에 있으며, 무단 사용 및 복제를 금합니다.
      </p>
    </section>

    <section>
      <h2>제10조 (분쟁 해결)</h2>
      <p>
        본 약관과 관련된 분쟁은 회사의 소재지를 관할하는 법원을 제1심 관할
        법원으로 합니다.
      </p>
    </section>

    <section>
      <h2>제11조 (서비스별 안내 및 이용 요금)</h2>
      <p>
        회사는 다음과 같은 주요 서비스를 제공합니다. 각 서비스의 상세한 이용
        요금 및 기능은 다음 표와 같습니다.
      </p>
      <table>
        <thead>
          <tr>
            <th>메뉴명</th>
            <th>이용 요금 (LYD)</th>
            <th>서비스 설명</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>실시간 운괘</td>
            <td>{{ LYD_HEXAGRAM }}</td>
            <td>
              주역 기반 지금 운세 서비스입니다. 서비스를 선택하는 그 순간의 운을
              결정할 괘와 효를 뽑아서 애정운, 금전운, 건강운, 사업(일)운의
              측면으로 해석해 드립니다. 결정된 운이 아니고 내가 불러오는
              운입니다.
            </td>
          </tr>
          <tr>
            <td>매일 사주 분석</td>
            <td>{{ LYD_QIFLOW }}</td>
            <td>
              나의 사주와 지금 시간의 사주에 흐르고 있는 오행의 기운과 현재
              날씨를 고려해서 색과 방향, 음식과 건강, 감정, 행동의 측면에서
              나에게 유익한 것과 조심해야 할 것들을 철학적으로 풀어드립니다.
            </td>
          </tr>
          <!--tr>
            <td>올해의 운세</td>
            <td>{{ LYD_FORTUNE }}</td>
            <td>
              당신의 사주에 들어있는 십신과 격국을 파악하고 올해의 년주가 미치는 영향을
              지지의 충(沖)·합(合)·형(刑)·파(破) 관계 등을 고려하여 풀어줍니다.
            </td>
          </tr-->
          <tr>
            <td>사주로 풀어보는 MBTI</td>
            <td>{{ LYD_MBTI }}</td>
            <td>
              동양철학의 기질 분류 체계(사주)와 현대 심리학의 성격 분류 체계(MBTI)의 접점을 찾아
              설문에 흔들리지 않는 안정적인 MBTI 해석을 제공합니다.        
            </td>
          </tr>
          <tr>
            <td>내가 보는 주역점</td>
            <td>{{ LYD_ICHING }}</td>
            <td>
              질문을 던지고, 마음을 담아 스스로 점을 치면, 그 결과를 주역의
              지혜로 풀어드립니다.
            </td>
          </tr>
          <tr>
            <td>64괘상(卦像) 공부</td>
            <td>무료</td>
            <td>
              주역 상·하경 전체 64괘의 각 괘상이 나타내는 상징과 의미를 간단히 
              해설해 드립니다.
            </td>
          </tr>
          <tr>
            <td>언집</td>
            <td>무료</td>
            <td>
              나와 내 주변을 돌아볼 수 있는 생각 시간을 가지게 해 주는 좋은 말
              모음입니다.
            </td>
          </tr>
        </tbody>
      </table>
    </section>

    <section class="company-info">
      <h2>[부칙]</h2>
      <p>이 약관은 2025년 6월 20일부터 시행합니다.</p>
      <p>상호명: 리디아트리</p>
      <p>사업자등록번호: 437-20-01228</p>
      <p>대표자: 노권형</p>
      <p>이메일: kayroh@lydiatree.co.kr</p>
      <p>주소: 경기도 용인시 동백중앙로 191, 8층 T817호</p>
    </section>
    <div class="button-container">
      <button class="confirm-button" @click="goBack">확인</button>
    </div>
  </div>
</template>

<script setup>
  import { useRouter } from 'vue-router'

  const LYD_FORTUNE = ref(import.meta.env.VITE_CHARGE_FORTUNE)
  const LYD_HEXAGRAM = ref(import.meta.env.VITE_CHARGE_HEXAGRAM)
  const LYD_MBTI = ref(import.meta.env.VITE_CHARGE_MBTI)
  const LYD_ICHING = ref(import.meta.env.VITE_CHARGE_ICHING)
  const LYD_QIFLOW = ref(import.meta.env.VITE_CHARGE_QIFLOW)  
  
  const router = useRouter()
  const goBack = () => {
    router.go(-1)
  }
</script>

<style scoped>
  .terms-container {
    max-width: 480px;
    margin: 0 auto;
    padding: 2rem;
    font-size: var(--font-size-095);
    line-height: 1.6;
  }
  .terms-container h1 {
    font-size: var(--font-size-14);
    margin-bottom: 1rem;
  }
  .terms-container h2 {
    font-size: var(--font-size-11);
    margin-top: 1.5rem;
  }
  .terms-container ul {
    padding-left: 1.5rem;
    list-style: disc;
  }
  table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 1rem;
    font-size: var(--font-size-095);
  }
  th,
  td {
    border: 1px solid #ccc;
    padding: 0.75rem;
    text-align: left;
    vertical-align: top;
  }
  th {
    background-color: #f9f9f9;
  }
  .company-info {
    margin-top: 2rem;
    font-size: var(--font-size-095);
    color: #666;
  }

  .button-container {
    margin-top: 2rem;
    display: flex;
    justify-content: center;
  }

  .confirm-button {
    padding: 0.7rem 1.5rem;
    font-size: var(--font-size-10);
    border: none;
    border-radius: 8px;
    background-color: #4caf50;
    color: white;
    cursor: pointer;
  }

  .confirm-button:hover {
    background-color: #45a049;
  }
</style>
